import { supabase, q } from './lib/supabase.js';
import * as Demo from './demo/demo.js';

/**
 * Substitui o seletor visual de colaborador do protótipo.
 * Antes: `let currentColaborador = 'Vitor'` — qualquer um virava qualquer um.
 * Agora: quem você é vem da sessão do Supabase Auth, e a RLS do banco
 * usa esse mesmo auth.uid() para decidir o que você pode escrever.
 */

let colaborador = null;   // { id, nome, email, papel, departamento, ativo }

export function usuario() {
  return colaborador;
}

export function ehGestao() {
  return colaborador?.papel === 'gestao';
}

export function iniciais(nome) {
  return (nome || '?')
    .split(' ')
    .filter(Boolean)
    .map((n) => n[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
}

/** Carrega o perfil do colaborador logado. null = sem sessão válida. */
export async function carregarSessao() {
  if (Demo.emDemonstracao) {   // guarda do modo demonstração
    colaborador = Demo.usuarioDemo;
    return colaborador;
  }

  const { data: { session } } = await supabase.auth.getSession();
  if (!session) {
    colaborador = null;
    return null;
  }

  const linhas = await q(
    supabase.from('colaboradores').select('*').eq('id', session.user.id).limit(1)
  );

  if (!linhas.length) {
    // Usuário existe no Auth mas não em colaboradores — não deveria acontecer
    // (há trigger para isso), mas se acontecer é melhor barrar do que quebrar.
    await supabase.auth.signOut();
    colaborador = null;
    throw new Error('Seu usuário não está cadastrado como colaborador. Fale com a gestão.');
  }

  if (!linhas[0].ativo) {
    await supabase.auth.signOut();
    colaborador = null;
    throw new Error('Seu acesso está desativado. Fale com a gestão.');
  }

  colaborador = linhas[0];
  return colaborador;
}

/**
 * Traduz o que o Supabase devolve. "Failed to fetch" é o caso mais comum
 * na prática (internet caiu, ou a URL do projeto está errada no .env) e
 * não diz nada para quem está usando o sistema.
 */
function mensagemAmigavel(mensagem) {
  if (/failed to fetch|networkerror|load failed/i.test(mensagem)) {
    return 'Não foi possível falar com o servidor. Verifique sua internet — se o problema continuar, avise a gestão.';
  }
  if (/invalid login credentials/i.test(mensagem)) {
    return 'E-mail ou senha incorretos.';
  }
  if (/email not confirmed/i.test(mensagem)) {
    return 'Seu e-mail ainda não foi confirmado. Procure o convite na caixa de entrada.';
  }
  if (/too many requests|rate limit/i.test(mensagem)) {
    return 'Muitas tentativas seguidas. Espere um minuto e tente de novo.';
  }
  return mensagem;
}

export async function entrar(email, senha) {
  const { error } = await supabase.auth.signInWithPassword({
    email: email.trim(),
    password: senha,
  });
  if (error) throw new Error(mensagemAmigavel(error.message));
  return carregarSessao();
}

export async function sair() {
  if (Demo.emDemonstracao) return Demo.sairDaDemonstracao();   // guarda do modo demonstração

  await supabase.auth.signOut();
  colaborador = null;
}

/** Reage a logout em outra aba, expiração de token etc. */
export function aoMudarSessao(callback) {
  supabase.auth.onAuthStateChange((evento) => {
    if (evento === 'SIGNED_OUT') {
      colaborador = null;
      callback(null);
    }
  });
}
